export const STATUS_MAP = Object.freeze({
  ONLINE: 0,
  OFFLINE: 1,
  BUSY: 2,
});
